import React from "react";
import "../../node_modules/react-modal-video/css/modal-video.css";
import headerImg1 from "../assets/images/dscn1374-1488x1116.jpg";

export default function Otizm() {
  return (
    <>
      <div className="container relative md:pb-24 pb-16">
        <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
          <div className="lg:col-span-12 md:col-span-12">
            <div className="relative">
              <div className="relative flex justify-center">
                <img
                  src={headerImg1}
                  className="rounded-xl shadow dark:shadow-gray-700"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-12 md:col-span-12">
            <div className="lg:ms-5">
              <h3
                className="mb-4 md:text-2xl text-xl font-medium"
                style={{ textAlign: "center" }}
              >
                Otizm Spektrum Bozukluğu Nedir?
              </h3>
              <p
                className="dark:text-white"
                style={{ textAlign: "justify", lineHeight: 2 }}
              >
                Otizm Spektrum Bozukluğu (OSB), erken çocukluk döneminde ortaya
                çıkan ve bireyin sosyal iletişim becerilerini, davranış
                kalıplarını etkileyen karmaşık bir nörogelişimsel bozukluktur.
                Bu durum, genellikle motor beceriler, boy ve kilo gelişimi gibi
                fiziksel alanlarda herhangi bir sorun yaratmaz. Otizmli bireyler
                genellikle dış görünüş itibariyle yaşıtlarından farklı değilken,
                bazı vakalarda büyük bir baş çevresi gibi fizyolojik
                farklılıklar gözlemlenebilir.
                <br />
                <br />
                Otizmin temel belirtileri sosyal etkileşimde zorluk, tekrarlayan
                davranışlar ve sınırlı ilgi alanları ile kendini gösterir. Bazen
                belirtiler bebeklikten itibaren fark edilirken, bazı bireylerde
                “mama”, “baba” gibi ilk kelimeler söylendikten sonra
                psiko-sosyal gelişimde duraksama veya gerileme meydana gelir.
                Otizmin, beynin yapısı ve işleyişini etkileyen sinir sistemi
                sorunlarından kaynaklandığı düşünülmektedir ve bu durum ailenin
                çocuk yetiştirme tarzı veya sosyo-ekonomik durumu ile
                ilişkilendirilmez. Otizm erkeklerde kızlara oranla dört kat daha
                sık görülmektedir, ancak bunun nedeni tam olarak
                bilinmemektedir.
              </p>
              <br />
              <h3
                className="mb-4 md:text-2xl text-xl font-medium"
                style={{ textAlign: "center" }}
              >
                Otizm Belirtileri Nelerdir?
              </h3>
              <p
                className="dark:text-white"
                style={{ textAlign: "justify", lineHeight: 2 }}
              >
                Otizmin belirtileri bireyden bireye değişiklik gösterse de,
                sosyal iletişim ve davranış kalıplarındaki zorluklar temel
                özelliklerdir:
                <br /> <br />
                1. Göz Teması Eksikliği: Otizmli çocuklar göz teması kurmada
                zorlanabilir. Kısa süreli ya da anlam yüklemeyen bakışlar
                yaygındır.
                <br />
                2. İsimle Tepki Vermeme: Adıyla çağrıldığında tepki vermeme
                yaygındır.
                <br />
                3. Konuşma Problemleri: Bazı bireyler hiç konuşmazken,
                bazılarında gecikmiş ya da tuhaf bir konuşma tarzı olabilir.
                Zamirleri ters kullanma (“ben” yerine “sen” deme gibi) veya
                ekolali (söylenenleri tekrar etme) görülebilir.
                <br />
                4. Taklit Zorlukları: Bay-bay yapma, selam verme gibi sosyal
                jestlerde gecikme ya da eksiklik görülebilir.
                <br />
                5. Sosyal İletişim Eksikliği: Yaşıtlarıyla oyun oynamaktan
                ziyade kendi başlarına olmayı tercih ederler. Grup oyunlarına
                katılma veya oyuncaklarla amaca uygun oynama konusunda
                isteksizlik görülebilir.
                <br />
                6. Tekrarlayan Hareketler: Sallanma, el çırpma, kanat çırpma
                gibi stereotipik hareketler sıktır.
                <br />
                7. Duyusal Hassasiyet: Ses, ışık, koku gibi uyaranlara karşı
                aşırı duyarlı olabilirler ve beklenmedik tepkiler verebilirler.
                <br />
                8. Temastan Kaçınma: Bebeklik döneminden itibaren kucakta
                sakinleşmemek ya da temastan rahatsız olmak sıktır.
                <br />
                9. Anlamsız Nesne Kullanımı: Arabaları ters çevirip
                tekerleklerini izleme, eşyaları dizme gibi sıra dışı oyun
                alışkanlıkları bulunabilir.
              </p>
              <br />
              <h3
                className="mb-4 md:text-2xl text-xl font-medium"
                style={{ textAlign: "center" }}
              >
                Otizmin Nedenleri
              </h3>
              <p
                className="dark:text-white"
                style={{ textAlign: "justify", lineHeight: 2 }}
              >
                Otizmin nedeni kesin olarak bilinmemekle birlikte, genetik ve
                çevresel faktörlerin etkili olduğu düşünülmektedir. Beyindeki
                nörogelişimsel farklılıklar, sinir sistemindeki işleyiş
                bozuklukları ile ilişkili bulunmuştur. Aşıların otizme neden
                olduğuna dair bilimsel bir kanıt yoktur.
                <br />
                <br />
                Otizm hakkında farkındalığın artması ve erken tanı, bireylerin
                yaşam kalitesini ve topluma entegrasyonunu önemli ölçüede
                iyileştirebilir. İlk belirtilerin fark edilmesi durumunda uzman
                bir hekime başvurulmalıdır.
              </p>{" "}
              <br />
              <h5>
                <strong>
                  Memorial Tıbbi Yayın Kurulu tarafından hazırlanmıştır.
                </strong>
                <br />
                <strong>Güncelleme Tarihi : 28 Mart 2022</strong>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
